import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getBettingCenterConfig() {
    const BASIC_FONT = {
        fontFamily: FONT.FAMILY,
        fontWeight: FONT.WEIGHT_SEMI_BOLD,
        textTransform: 'uppercase',
        fontStyle: 'normal',
    };
    const COMMON_FUTURA = {
        fontFamily: FONT.FAMILY_FUTURA,
        fontWeight: FONT.WEIGHT_FUTURA_BOLD,
        textTransform: 'uppercase',
        fontStyle: 'italic',
        fontSize: FONT.SIZE_MEDIUM,
    };

    return {
        custom: {
            [PALETTE_IDS.YOUR_BETS]: {
                YourBetView: {
                    bestOddsIcon: {
                        style: {
                            paddingTop: '2px',
                        },
                    },
                },
            },
            [PALETTE_IDS.OVERASK]: {
                OveraskView: {
                    timer: {
                        timeString: {
                            style: {
                                wordWrap: 'normal',
                            },
                        },
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.BET_RECEIPT]: {
                BET_RECEIPT_BET_HEADER_TEXT: {
                    ...COMMON_FUTURA,
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: 20, // Zeplin
                },
                BET_RECEIPT_EVENT_NOTIFICATIONS_SWITCH: {
                    SWITCH_LABEL_TEXT: {
                        ...COMMON_FUTURA,
                        color: COLOR.BRAND.FOREGROUND1,
                        fontSize: FONT.SIZE_XSMALL,
                    },
                },
            },
            [PALETTE_IDS.BETTING_CENTER]: {
                BETTING_CENTER_TAB_BUTTON_BG: COLOR.BRAND.BACKGROUND4,
                BETTING_CENTER_TAB_BUTTON_TEXT: {
                    ...COMMON_FUTURA,
                    color: COLOR.BRAND.FOREGROUND1,
                },

                BETTING_CENTER_BET_CONTAINER_BG: COLOR.BRAND.BACKGROUND4,
            },
            [PALETTE_IDS.BETSLIP]: {
                BETSLIP_BB_BET_CONTAINER_BG: COLOR.BASE.PAGE,
                SLIDING_BETSLIP_BUTTON_HIGHLIGHTED_BG: COLOR.BRAND.CTA2,
                BETSLIP_REMOVE_ALL_BUTTON: {
                    TERTIARY_BUTTON_TEXT: {
                        ...COMMON_FUTURA,
                        color: COLOR.BRAND.CTA1,
                    },
                },

                BETSLIP_REMOVE_BET_BUTTON: {
                    CLOSE_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                },

                BETSLIP_BET_HIGHLIGHT_INDICATOR_COLOR: COLOR.SEMANTIC.WARNING2,

                BETSLIP_BET_SHOW_ODDS_BUTTON: {
                    SECONDARY_LINK_TEXT: {
                        fontFamily: FONT.FAMILY,
                        color: COLOR.BRAND.ACCENT1,
                        fontSize: FONT.SIZE_XSMALL,
                        fontWeight: FONT.WEIGHT_NORMAL,
                        textTransform: 'capitalize',
                        fontStyle: 'normal',
                    },
                },

                BETSLIP_BANKERS_BET_BUTTON: {
                    TOGGLE_BUTTON_TEXT: {
                        fontFamily: FONT.FAMILY,
                        fontStyle: 'normal',
                        color: COLOR.BRAND.FOREGROUND1,
                    },
                    TOGGLE_BUTTON_SELECTED_TEXT: {
                        fontFamily: FONT.FAMILY,
                        fontStyle: 'normal',
                        color: COLOR.BRAND.FOREGROUND4,
                    },
                },

                BETSLIP_BB_BET_ICON_COLOR: COLOR.BRAND.CTA1,
                BETSLIP_BB_BET_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },

                // Freebets
                BETSLIP_FREE_BETS_HEADER_ROTATION_ICON_COLOR: COLOR.BRAND.CTA1,
                BETSLIP_FREE_BETS_HEADER_TEXT: {
                    ...COMMON_FUTURA,
                    fontSize: FONT.SIZE_SMALL,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                BETSLIP_FREE_BETS_SWITCH: {
                    SWITCH_LABEL_TEXT: {
                        ...COMMON_FUTURA,
                        fontSize: FONT.SIZE_XSMALL,
                        color: COLOR.BRAND.FOREGROUND1,
                    },
                    SWITCH_DISABLED_LABEL_TEXT: {
                        ...COMMON_FUTURA,
                        fontSize: FONT.SIZE_XSMALL,
                        color: COLOR.BRAND.FOREGROUND5,
                    },
                },
                // Settings
                BETSLIP_SETTINGS_SWITCH: {
                    SWITCH_LABEL_TEXT: {
                        ...COMMON_FUTURA,
                        fontSize: FONT.SIZE_XSMALL,
                        color: COLOR.BRAND.FOREGROUND4,
                    },
                    SWITCH_DISABLED_LABEL_TEXT: {
                        ...COMMON_FUTURA,
                        fontSize: FONT.SIZE_XSMALL,
                        color: COLOR.BRAND.FOREGROUND5,
                    },
                },
                // Total info
                BETSLIP_BET_POTENTIAL_RETURNS_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: FONT.SIZE_XSMALL,
                },
                // Sliding betslip
                SLIDING_BETSLIP_BUTTON_FREEBETS_CONTAINER_BG: COLOR.BRAND.FOREGROUND4,
                SLIDING_BETSLIP_BUTTON_FREEBETS_ICON_COLOR: COLOR.BRAND.BACKGROUND2,
            },
            [PALETTE_IDS.NUMERIC_KEYPAD]: {
                KEYPAD_CONTAINER_BG: COLOR.BRAND.BACKGROUND4,
                KEYPAD_COMPACT_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                KEYPAD_INCREASE_BUTTON_BG: COLOR.BRAND.FOREGROUND5,
                KEYPAD_BUTTON: {
                    TOGGLE_BUTTON_TEXT: {
                        ...BASIC_FONT,
                        color: COLOR.BRAND.FOREGROUND1,
                    },
                    TOGGLE_BUTTON_SELECTED_TEXT: {
                        ...BASIC_FONT,
                        color: COLOR.BRAND.FOREGROUND4,
                    },
                },
                KEYPAD_COMPACT_BUTTON: {
                    TOGGLE_BUTTON_TEXT: {
                        ...BASIC_FONT,
                        color: COLOR.BRAND.FOREGROUND1,
                    },
                    TOGGLE_BUTTON_SELECTED_TEXT: {
                        ...BASIC_FONT,
                        color: COLOR.BRAND.FOREGROUND4,
                    },
                },
            },
            [PALETTE_IDS.YOUR_BETS]: {
                OPEN_BET_LIVE_EVENT_TIMING_STATUS: {
                    EVENT_TIMING_LIVE_TEXT: COLOR.BRAND.FOREGROUND3,
                },
                OPEN_BET_LIVE_EVENT_DATA_SEPARATOR: COLOR.BASE.DIVIDER2,
                OPEN_BET_LIVE_EVENT_SCOREBOARD: {
                    MINI_SCOREBOARD_SCORES_TEXT: {
                        fontSize: FONT.SIZE_SMALL,
                        color: COLOR.BRAND.ACCENT1,
                    },
                    MINI_SCOREBOARD_SCORE_COUNT_TEXT: {
                        fontSize: FONT.SIZE_SMALL,
                        color: COLOR.BRAND.ACCENT1,
                    },
                },
                OPEN_BET_RESULT_TEXT: COLOR.BRAND.ACCENT1,
            },
            [PALETTE_IDS.OVERASK]: {
                OVERASK_TIMER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_NORMAL,
                },
                OVERASK_BET_OFFER_CONTAINER_BG: COLOR.BRAND.BACKGROUND4,
                OVERASK_TRADER_BET_OFFER_CONTAINER_BG: COLOR.BRAND.BACKGROUND4,
                OVERASK_BET_OFFER_BG: COLOR.BRAND.BACKGROUND1,
                OVERASK_BET_OFFER_STATUS_TITLE_TEXT: {
                    ...COMMON_FUTURA,
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: 20, // Zeplin
                },
                OVERASK_BET_OFFER_HEADER_TEXT: {
                    ...COMMON_FUTURA,
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: FONT.SIZE_XLARGE,
                },
            },
        },
    };
}
